import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue, Tabs, TabsContent, TabsList, TabsTrigger } from '@sushiswap/ui';
import React, { FC, useState } from 'react';
import { isSmartPoolChainId } from '@sushiswap/graph-client/data-api';
import { ChainKey } from 'sushi/chain';
import { SushiSwapChainId } from 'sushi/config';
import { ConcentratedPositionsTable } from './ConcentratedPositionsTable/ConcentratedPositionsTable';
import { PositionsTable } from './PositionsTable';
import { SmartPositionsTable } from './SmartPositionsTable';
const ITEMS: {
  id: string;
  value: string;
  children: React.ReactNode;
}[] = [{
  id: 'sushiswap-v3',
  value: 'v3',
  children: <div className="flex items-center gap-2">
        <span>🍣</span>{' '}
        <span>
          SushiSwap <sup>v3</sup>
        </span>
      </div>
}, {
  id: 'sushiswap-v2',
  value: 'v2',
  children: <div className="flex items-center gap-2">
        <span>🍣</span>{' '}
        <span>
          SushiSwap <sup>v2</sup>
        </span>
      </div>
}, {
  id: 'sushiswap-smart',
  value: 'smart',
  children: <div className="flex items-center gap-2">
        <span>💡</span>
        <span>Smart Pool</span>
      </div>
}];
export const PositionsTab: FC<{
  chainId: SushiSwapChainId;
}> = ({
  chainId
}) => {
  const [tab, setTab] = useState('v3');
  return <div className="flex flex-col gap-4" data-sentry-component="PositionsTab" data-sentry-source-file="PositionsTab.tsx">
      <Tabs value={tab} onValueChange={setTab} defaultValue="v3" data-sentry-element="Tabs" data-sentry-source-file="PositionsTab.tsx">
        <div className="flex justify-between mb-4">
          <div className="block sm:hidden">
            <Select value={tab} onValueChange={setTab} data-sentry-element="Select" data-sentry-source-file="PositionsTab.tsx">
              <SelectTrigger data-sentry-element="SelectTrigger" data-sentry-source-file="PositionsTab.tsx">
                <SelectValue placeholder="Pool type" data-sentry-element="SelectValue" data-sentry-source-file="PositionsTab.tsx" />
              </SelectTrigger>
              <SelectContent data-sentry-element="SelectContent" data-sentry-source-file="PositionsTab.tsx">
                {ITEMS.map(item => <SelectItem key={item.value} value={item.value}>
                    {item.children}
                  </SelectItem>)}
              </SelectContent>
            </Select>
          </div>
          <TabsList className="hidden sm:inline-flex" data-sentry-element="TabsList" data-sentry-source-file="PositionsTab.tsx">
            {ITEMS.map(item => <TabsTrigger key={item.value} value={item.value} testdata-id={item.id}>
                {item.children}
              </TabsTrigger>)}
          </TabsList>
        </div>
        <TabsContent value="v3" data-sentry-element="TabsContent" data-sentry-source-file="PositionsTab.tsx">
          <ConcentratedPositionsTable chainId={chainId} hideNewPositionButton={true} data-sentry-element="ConcentratedPositionsTable" data-sentry-source-file="PositionsTab.tsx" />
        </TabsContent>
        <TabsContent value="v2" data-sentry-element="TabsContent" data-sentry-source-file="PositionsTab.tsx">
          <PositionsTable chainId={chainId} rowLink={row => `/${ChainKey[chainId]}/pool/v2/${row.pool.address}/add`} data-sentry-element="PositionsTable" data-sentry-source-file="PositionsTab.tsx" />
        </TabsContent>
        {isSmartPoolChainId(chainId) ? <TabsContent value="smart">
            <SmartPositionsTable chainId={chainId} />
          </TabsContent> : null}
      </Tabs>
    </div>;
};